//INIT
import React, { useContext, useEffect, useState } from "react"
import { useDrop } from "react-dnd"

import ServicosContext from "../../../contexts/servicosContext"

import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"

import Accordion from "@material-ui/core/Accordion"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import CircularProgress from "@material-ui/core/CircularProgress"
import List from "@material-ui/core/List"
import Typography from "@material-ui/core/Typography"
import { Row } from "react-bootstrap"
import { totalArray } from "../../../pages/RecebedorDePedidos/functions"

import { Checkbox, IconButton } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import RingAudio from "../audios/ring.mp3"
import Card from "../cards/Card"

const useStyles = makeStyles({
    botoesAvancar_container: {
        display: "inline-flex",
        float: "right",
        gap: "8px",
    },
})

const BotaoAvancar = ({
    array,
    mudarStatusPara,
    autorizacao,
    indexLista,
    listaPedidosSelecionados,
    setListaPedidosSelecionados,
    tabStatus,
    procurarMotoqueiros,
    integradoComUber,
}) => {
    const classes = useStyles()

    const proximoStatus = (pedido, indexLista) => {
        switch (indexLista) {
            case 2:
                if (pedido.type == "0") {
                    return 3
                } else {
                    return 6
                }
            case 3:
                return 4
            default:
                return null
        }
    }

    const mudarStatus = (pedido, indexPedido) => {
        mudarStatusPara(proximoStatus(pedido, indexLista), autorizacao, pedido, indexPedido)
    }

    // const classIcon = () => {
    //     switch (indexLista) {
    //         case 2:
    //             return classes.iconNext3
    //         case 3:
    //             return classes.iconNext4
    //         default:
    //             return {}
    //     }
    // }

    if (indexLista === 4) return null

    return (
        <div className={classes.botoesAvancar_container}>
            {indexLista !== 3 && !integradoComUber && (
                <IconButton
                    style={{ padding: "0px", backgroundColor: "white", color: "#000a" }}
                    onClick={e => {
                        if (tabStatus === "CRUD") {
                            procurarMotoqueiros(autorizacao, "#", [listaPedidosSelecionados])
                        }

                        setListaPedidosSelecionados({})

                        e.stopPropagation()
                    }}
                >
                    <MotorcycleIcon />
                </IconButton>
            )}
            <IconButton
                style={{ padding: "0px", backgroundColor: "white" }}
                onClick={e => {
                    e.stopPropagation()

                    const listaAtualizada = JSON.parse(JSON.stringify(listaPedidosSelecionados))

                    for (const pedidoSelecionado in listaAtualizada) {
                        if (!listaAtualizada[pedidoSelecionado].checked) continue

                        const pedidoNaLista = array.find(
                            pedido => pedido.id === Number(pedidoSelecionado)
                        )

                        mudarStatus(pedidoNaLista, listaAtualizada[pedidoNaLista.id].indexPedido)

                        delete listaAtualizada[pedidoSelecionado]
                    }

                    setListaPedidosSelecionados(listaAtualizada)
                }}
            >
                <NavigateNextIcon />
            </IconButton>
        </div>
    )
}

const RingAudioPlayer = props => {
    return (
        <audio
            src={RingAudio}
            style={{ width: "100%" }}
            loop={props.loop}
            id="audiopedido"
            controls="controls"
        />
    )
}

export default function Lista(props) {
    const { configuracoes } = useContext(ServicosContext)

    const {
        mostrar,
        loading,
        array,
        classes,
        autorizacao,
        procurarMotoqueiros,
        solicitarEntregaFuiDelivery,
        buscarStatus,
        impressorasQZ,
        mandarImprimir,
        setModalInformacoes,
        setModalInformacoesPedido,
        setModalInformacoesPedidoIndex,
        tabStatus,
        mudarStatusPara,
        indexLista,
        tipoPainelImpressao,
    } = props

    const [listaPedidosSelecionados, setListaPedidosSelecionados] = useState({})
    const [mostrarBotaoAvancar, setMostrarBotaoAvancar] = useState(false)

    useEffect(() => {
        setMostrarBotaoAvancar(JSON.stringify(listaPedidosSelecionados).includes("true"))
    }, [listaPedidosSelecionados])

    const classAccordion = () => {
        switch (indexLista) {
            case 1:
                return classes.primeiro
            case 2:
                return classes.segundo
            case 3:
                return classes.terceiro
            case 4:
                return classes.quarto
            default:
                return {}
        }
    }

    const listaStatusPrincipal = (indexLista, pedido) => {
        console.log("listastauts", pedido)
        if (indexLista === 1) {
            return 0
        } else if (indexLista === 2) {
            return 7
        } else if (indexLista === 3) {
            // if(pedido.deliveryAddress?.streetName?.includes("Buscar no local")){
            if (pedido.type === "0") {
                //delivery
                return 3 //saiu para entrega
            } else {
                // mesa ou retirada
                return 6 //Pronto P/ Retirada
            }
        } else if (indexLista === 4) {
            return 4
        } else {
            return -1
        }
    }

    const classQuantidade = () => {
        switch (indexLista) {
            case 1:
                return "quantidadePrimeiro"
            case 2:
                return "quantidadeSegundo"
            case 3:
                return "quantidadeTerceiro"
            case 4:
                return "quantidadeQuarto"
            default:
                return ""
        }
    }
    const titleLista = () => {
        switch (indexLista) {
            case 1:
                if (configuracoes.recebedor.aceitarPedidoAutomatico) {
                    return " Aceito"
                } else {
                    return " Aguardando Aceitação"
                }
            case 2:
                if (configuracoes.recebedor.aceitarPedidoAutomatico) {
                    return " Em Preparação"
                } else {
                    return " Aceito"
                }
            case 3:
                return " Em Entrega"
            case 4:
                return " Finalizado"
            default:
                return ""
        }
    }
    const exibirTotal = () => {
        if (configuracoes?.user?.perfil === "DELIVERY_BASICO") return <></>

        switch (indexLista) {
            case 4:
                return (
                    <>
                        {!loading && (
                            <span className="totalP">
                                {Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                }).format(totalArray(1, array))}
                            </span>
                        )}
                    </>
                )
            default:
                return <></>
        }
    }
    const nenhumPedidoTexto = () => {
        switch (indexLista) {
            case 1:
                if (configuracoes.recebedor.aceitarPedidoAutomatico) {
                    return " Nenhum Pedido Aceito"
                } else {
                    return " Nenhum Pedido Aguardando Aceitação"
                }
            case 2:
                if (configuracoes.recebedor.aceitarPedidoAutomatico) {
                    return " Nenhum Pedido Em Preparação"
                } else {
                    return " Nenhum Pedido Aceito"
                }
            case 3:
                return " Nenhum Pedido Em Entrega"
            case 4:
                return " Nenhum Pedido Finalizado"
            default:
                return ""
        }
    }

    const [, dropRef] = useDrop({
        accept: "CARD",
        drop(props, monitor, component) {
            console.log("props, monitor, component", props, monitor, component)
            const indexListaNova = indexLista

            if (props.indexListaAtual == indexListaNova) {
                return
            }

            console.log(props.indexListaAtual, " to ", indexListaNova)

            mudarStatusPara(
                listaStatusPrincipal(indexListaNova, props.pedido),
                autorizacao,
                props.pedido,
                props.indexPedido
            )
        },
    })

    return (
        <Row ref={dropRef} style={{ margin: "10px 0" }}>
            <Accordion expanded={!!mostrar} style={{ width: "100%" }}>
                <AccordionSummary className={classAccordion()}>
                    <Typography component={"span"} className={classes.heading}>
                        <span className={classQuantidade()}>
                            {loading ? (
                                <CircularProgress
                                    color="inherit"
                                    style={{ width: "15px", height: "15px" }}
                                />
                            ) : array.length < 10 ? (
                                "0" + array.length
                            ) : (
                                array.length
                            )}
                        </span>
                        {titleLista()}

                        {exibirTotal()}

                        <span>
                            {(indexLista === 2 || indexLista === 3) && (
                                <Checkbox
                                    checked={mostrarBotaoAvancar}
                                    onChange={e => {
                                        e.persist()
                                        array.forEach((pedido, index) =>
                                            setListaPedidosSelecionados(lista => ({
                                                ...lista,
                                                [pedido.id]: {
                                                    id: pedido.id,
                                                    checked: e.target.checked,
                                                    indexPedido: index,
                                                },
                                            }))
                                        )
                                        setMostrarBotaoAvancar(prev => !prev)
                                    }}
                                    style={{
                                        padding: "0px",
                                        margin: "2px 8px 0 8px",
                                        float: "right",
                                        // marginLeft: window.screen.width > 767 ? "24px" : "100px",
                                    }}
                                    size="small"
                                    name="efeito-sonoro"
                                />
                            )}
                            {mostrarBotaoAvancar && (
                                <BotaoAvancar
                                    procurarMotoqueiros={procurarMotoqueiros}
                                    autorizacao={autorizacao}
                                    indexLista={indexLista}
                                    listaPedidosSelecionados={listaPedidosSelecionados}
                                    setListaPedidosSelecionados={setListaPedidosSelecionados}
                                    mudarStatusPara={mudarStatusPara}
                                    array={array}
                                    tabStatus={tabStatus}
                                    integradoComUber={
                                        configuracoes.user?.parametros?.possuiIntegracaoUber
                                    }
                                />
                            )}
                        </span>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ padding: "10px" }}>
                    <List className={classes.rootList} style={{ textAlign: "center" }}>
                        {configuracoes.recebedor.efeitoSonoro &&
                        (indexLista === 1 ||
                            (indexLista == 2 &&
                                configuracoes.recebedor.prepararPedidoAutomatico === true)) ? (
                            <RingAudioPlayer
                                loop={!configuracoes.recebedor.prepararPedidoAutomatico}
                            />
                        ) : null}

                        {loading ? (
                            <CircularProgress color="inherit" />
                        ) : array.length === 0 ? (
                            nenhumPedidoTexto()
                        ) : (
                            <React.Fragment>
                                {array.map((pedido, index) => (
                                    <Card
                                        tipoPainelImpressao={tipoPainelImpressao}
                                        key={index}
                                        indexLista={indexLista}
                                        pedido={pedido}
                                        buscarStatus={buscarStatus}
                                        indexPedido={index}
                                        procurarMotoqueiros={procurarMotoqueiros}
                                        solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                                        autorizacao={autorizacao}
                                        mudarStatusPara={mudarStatusPara}
                                        mandarImprimir={mandarImprimir}
                                        impressorasQZ={impressorasQZ}
                                        tabStatus={tabStatus}
                                        setModalInformacoes={setModalInformacoes}
                                        setModalInformacoesPedidoIndex={
                                            setModalInformacoesPedidoIndex
                                        }
                                        setModalInformacoesPedido={setModalInformacoesPedido}
                                        classes={classes}
                                        listaPedidosSelecionados={listaPedidosSelecionados}
                                        setListaPedidosSelecionados={setListaPedidosSelecionados}
                                    />
                                ))}
                            </React.Fragment>
                        )}
                    </List>
                </AccordionDetails>
            </Accordion>
        </Row>
    )
}
